import { styled } from '@material-ui/core';
import { Link } from 'react-router-dom';

export const CleanLink = styled(Link)({
    color: 'inherit !important',
    textDecoration: 'inherit !important'
});
